import { ProLayout } from '@ant-design/pro-layout';
import { Result } from 'antd';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import InactivityTimeout from '../../icons/inactivityTimeout.svg';
import HeaderLogo from '../../layouts/HeaderLogo';
import ApplyCompanyTheming from '../contexts/ApplyCompanyTheming';
import { useCompany } from '../contexts/CompanyContextManager';
import Footer from '../Footer';

const StyledProLayout = styled(ProLayout)`
    .ant-layout {
        background-color: #ffffff;
    }

    .ant-pro-global-header {
        padding: 0 24px;
    }

    & .ant-result-title {
        font-weight: 700;
        margin-bottom: 1rem;
    }

    & .ant-result-subtitle {
        color: #000;
    }
`;

const footerRender = () => <Footer themeSpecific />;

const headerContentRender = () => <HeaderLogo link="/" />;

const InvalidLinkResult = () => {
    const company = useCompany(true);

    const { t } = useTranslation('common');

    const menuRender = useCallback(() => <div />, []);

    const content = useMemo(
        () => (
            <StyledProLayout
                footerRender={footerRender}
                headerContentRender={headerContentRender}
                headerHeight={80}
                headerTheme="light"
                layout="mix"
                logo={null}
                menuRender={menuRender}
                title={false}
            >
                <Result
                    icon={<InactivityTimeout />}
                    subTitle={t('common:errors.expired.description')}
                    title={t('common:errors.expired.title')}
                />
            </StyledProLayout>
        ),
        [menuRender, t]
    );

    if (!company) {
        return content;
    }

    return <ApplyCompanyTheming>{content}</ApplyCompanyTheming>;
};

export default InvalidLinkResult;
